import { render } from "./EditTopicView.vue?vue&type=template&id=029ca340"
import script from "./EditTopicView.vue?vue&type=script&lang=js"
export * from "./EditTopicView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__